module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form-builder-editor-field', _vm._g({
    attrs: {
      "item": _vm.item,
      "show-required": true,
      "show-hide-in-form": true,
      "show-hide-in-reports": true,
      "show-hide-in-preview": true
    }
  }, _vm.$listeners), [_c('form-builder-shared-field', {
    attrs: {
      "loading": false,
      "field-data": _vm.field,
      "form-id": _vm.id,
      "field-name": _vm.item.name
    },
    on: {
      "update": function($event) {
        return _vm.updateSharedField(_vm.item.name, $event)
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5bd7e081","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formbuilder/editors/FormBuilderEditorSharedField.vue
// module id = 1652
// module chunks = 1